import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { TableCell } from '@components/common/Table/TableCell/TableCell';
import { TableRow } from '@components/common/Table/TableRow/TableRow';
import { IProductRowProps } from './types';
import { CloneIcon } from '@components/common/Icons/CloneIcon';
import { EditIcon } from '@components/common/Icons/EditIcon';
import { rowDataFormatter } from './rowDataFormatter';
import { productsCloningAccessUsers, productsEditingAccessUsers, tableColumnsNames } from '../types';
import { getPageURL, getPageURLWithSection, PageURL } from '@router/pageURL';
import { AccessWrapper } from '@components/AccessWrapper/AccessWrapper';
export const ProductRow: FC<IProductRowProps> = ({ className, index, ...rowData }) => {
  const [open, setOpen] = useState(false);
  const { headersCells, bodyCells } = rowDataFormatter(rowData, index);

  return (
    <>
      <TableRow
        data-testid={'productRow'}
        className={[rowData.isActive ? '' : 'opacity-50', open ? '[&>td]:border-b-0' : '', className]
          .filter(Boolean)
          .join(' ')}
      >
        <TableCell>
          <Button
            type={'text'}
            data-testid={'expand-button'}
            aria-label={'expand row'}
            className={'flex! h-8! w-8! min-w-8! items-center! justify-center! p-0!'}
            icon={open ? <UpOutlined /> : <DownOutlined />}
            onClick={() => setOpen(!open)}
          />
        </TableCell>
        {headersCells.map(({ cell }) => cell)}
        <AccessWrapper accessGroups={productsEditingAccessUsers}>
          <TableCell>
            <div className={'flex items-center gap-2'}>
              <Link
                to={getPageURL(PageURL.PRODUCTS_EDIT, { id: rowData.id })}
                aria-label={'Edit Product'}
                className={'text-ash inline-flex'}
              >
                <EditIcon />
              </Link>
              <AccessWrapper accessGroups={productsCloningAccessUsers}>
                <Tooltip title={'Clone Product'}>
                  <Link
                    to={getPageURLWithSection(PageURL.PRODUCTS_NEW, undefined, { cloneFromProductId: rowData.id })}
                    aria-label={'Clone Product'}
                    className={'text-ash inline-flex'}
                  >
                    <CloneIcon />
                  </Link>
                </Tooltip>
              </AccessWrapper>
            </div>
          </TableCell>
        </AccessWrapper>
      </TableRow>
      <TableRow>
        <TableCell
          className={['p-0!', open ? 'border-b! border-solid! border-black/12!' : 'border-b-0!']
            .filter(Boolean)
            .join(' ')}
          colSpan={tableColumnsNames.length + 2}
        >
          <div
            className={`grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out ${
              open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
            }`}
          >
            <div className={'min-h-0'}>
              <div className={'grid grid-cols-4 grid-rows-2 gap-x-5 gap-y-2 p-2'}>
                {bodyCells.map(({ cell }) => cell)}
              </div>
            </div>
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};
